export default __webpack_public_path__ + "static/Wix-11f6531d24000877f470ca5ab696f738.png";